import React from "react";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

// Call it once in your app. At the root of your app is the best place
//toast.configure() - we use ToastContainer

/**
 * Główny layout całej aplikacji. Zawiera globalny TOAST
 */
class ParentLayout extends React.Component {

    render() {
        return (
            <div className="parentLayout">
                {this.props.children}
                <ToastContainer autoClose={4000} newestOnTop={true} />
            </div>
        );
    }

}

export default ParentLayout;
